export default __webpack_public_path__ + "static/media/photo--lg--misc-5.0b4bf2a7.jpg";